import $ from 'jquery'
import { ajaxReturnIdAndName } from 'lib/select_ajax'

const LIGHT_POSE_SELECT = "#js_light_poses_search"

$(function () {
    if (LIGHT_POSE_SELECT) {
        ajaxReturnIdAndName(LIGHT_POSE_SELECT, "光標籤", "/search_lights", "lights")
    }
})